import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useI18n } from "@/i18n/I18nProvider";
import { arFont, enFont } from "@/styles/font";


const FeedbackButton = ({  onToggle}) => {
 const { t, locale } = useI18n();


  return (
    <Box
      onClick={onToggle}
            className={locale == "en" ? enFont.className : arFont.className}
      
      sx={{
        position: "fixed",
        top: "30%",
        [locale === "en" ? "left" : "right"]: 0,
        [locale === "en" ? "ml" : "mr"]: "-15px",
        transform:
          locale === "en"
            ? "rotate(90deg) translateY(100%)"
            : "rotate(-90deg) translateY(100%)",
        transformOrigin: "center",
        width: { xs: "120px", sm: "150px" },
        height: { xs: "32px", sm: "40px" },
        backgroundColor: "#212564",
        color: "#fff",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px",
        zIndex: 999,
        cursor: "pointer",
      }}
    >
      <Typography
        sx={{
          fontWeight: { xs: "400", sm: "500" },
          fontSize: { xs: "12px", sm: "18px" },
          lineHeight: "16px",
          transform: "rotate(180deg)",
          transformOrigin: "center",
          textAlign:"center",
        }}
      >
        {t.feedback.buttonTitle}
      </Typography>
    </Box>
  );
};

export default FeedbackButton;
